import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const SimulatorContainer = React.lazy(
  () => import('../../containers/simulator/simulator.container')
);

const { SIMULATOR } = APP_ROUTES.AI_SIMULATOR_MODULE.CHILDREN as RouteConfig;
const simulatorPath = SIMULATOR.FULL_PATH;

export const AiSimulatorRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={simulatorPath} />
  },
  {
    path: simulatorPath,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.SALES_MANAGER, UserRole.SALES_AGENT]}
          component={SimulatorContainer}
        />
      </React.Suspense>
    )
  }
];
